import styled, { css } from 'styled-components';

import Text from '~components/Text';
import { getFontStyle } from '~components/Text/helper';
import { DESKTOP_WIDTH, HEADER_HEIGHT } from '~constant/layout';

export const Logo = styled.div<{ hasLogo?: boolean }>`
  width: 80px;
  height: 80px;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  & > img {
    width: ${(props) => (props.hasLogo ? '70px' : '40px')};
    height: ${(props) => !props.hasLogo && '25px'};
  }

  ${({ theme }) => theme.media.mobile} {
    width: 48px;
    height: 48px;

    & > img {
      width: ${(props) => (props.hasLogo ? '40px' : '32px')};
    }
  }
`;

export const logoCss = css`
  width: 80px;
  height: 80px;
  margin-right: 30px;

  & > img {
    width: 40px;
    height: 25px;
  }

  ${({ theme }) => theme.media.mobile} {
    width: 48px;
    height: 48px;

    margin: 30px 0 0 0;

    & > img {
      width: 32px;
    }
  }
`;
export const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;

  ${({ theme }) => theme.media.mobile} {
    text-align: center;

    & > span:first-child {
      ${getFontStyle('bold150_H5')}
    }
  }

  & svg {
    margin-bottom: 2px;
  }
`;

const Active = css`
  & > svg > path {
    fill: #d63461;
    stroke: #d63461;
  }
`;

export const Button = styled.button<{ isActive: boolean }>`
  background: ${({ theme }) => theme.colors.gray300};
  border: none;
  box-sizing: border-box;
  border-radius: 100px;
  padding: 9.5px 30px;
  margin-left: auto;
  align-items: center;
  display: flex;
  color: ${({ theme }) => theme.colors.gray800};

  & > svg {
    margin-right: 12px;
  }

  ${(props) => props.isActive && Active}
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
  margin-left: auto;
`;

export const Content = styled.div`
  max-width: ${DESKTOP_WIDTH}px;
  min-height: 140px;
  margin: auto;
  display: flex;
  align-items: center;

  ${({ theme }) => theme.media.tablet} {
    width: 100%;
    max-width: none;
    padding: 0 32px;
    margin: inherit;
  }

  & > ${Logo} {
    margin-right: 30px;
  }

  & > ${CompanyInfo} a {
    color: #7ac8c1;
  }

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    min-height: 246px;

    & > ${Logo} {
      margin: 30px 0 0 0;
    }

    & > ${CompanyInfo} > span {
      margin: 12px 0 6px 0;
    }

    & > ${ActionButtons} {
      margin: 20px 0 30px 0;
    }
  }
`;

export const CompanyInfoItem = styled.div`
  display: flex;
  margin-top: 2px;
  margin-bottom: 4px;
  align-items: center;

  svg {
    margin-right: 5px;
  }

  img {
    width: 2px;
    height: 2px;
    margin-left: 8px;
    margin-right: 9.5px;
  }

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    margin-bottom: 8px;
  }
`;

export const TextItem = styled.div``;
export const Menu = styled.a<{ isSelected?: boolean }>`
  &:focus {
    text-decoration: none;
    color: #444;
    outline: none;
  }

  height: 100%;
  align-items: center;
  display: flex;
  cursor: pointer;
  flex: 0 0 auto;
  scroll-snap-align: start;
  ${(props) => (props.isSelected ? 'color:   #d63461 !important;' : 'color: #444;')}
  ${(props) => (props.isSelected ? 'border-bottom: 3px solid' : 'border-bottom: 3px solid #fff')}
`;

export const StickyEmptyBlock = styled.p<{ isSticky: boolean }>`
  ${(props) =>
    !props.isSticky &&
    css`
      height: ${HEADER_HEIGHT}px;
      content: '';
      display: block;
      width: 100%;
    `}
`;

const Sticky = css`
  position: fixed;
  top: ${HEADER_HEIGHT}px;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 999;
  border-top: none;
`;

export const MenuWrapper = styled.nav<{ isSticky: boolean }>`
  height: ${HEADER_HEIGHT}px;
  border-top: 1px solid #ebebeb;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.08);

  ${(props) => !props.isSticky && Sticky}

  & > div {
    overflow-x: hidden;
    overflow-y: hidden;
    overscroll-behavior: contain;
    mouse-wheel: horizontal;

    max-width: ${DESKTOP_WIDTH}px;
    display: flex;
    margin: auto;
    align-items: center;
    height: 100%;
    gap: 60px;

    ${({ theme }) => theme.media.tablet} {
      width: 100%;
      max-width: none;
      padding: 0 32px;
    }

    ${({ theme }) => theme.media.mobile} {
      gap: 0;
      padding: 0 16px;
      gap: 32px;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const ActionButtonGroup = styled.div<{ isVisibility: boolean }>`
  margin-left: auto;
  ${(props) =>
    props.isVisibility &&
    css`
      visibility: hidden;
    `}
`;
export const Wrapper = styled.section`
  text-align: left;
  width: 100%;
  min-height: 1px;
  background-color: ${({ theme }) => theme.colors.white100};
`;

export const ButtonText = styled(Text)`
  color: ${({ theme }) => theme.colors.gray900};
`;
